import { render } from "./AposCombo.vue?vue&type=template&id=60a7f9c0&scoped=true"
import script from "./AposCombo.vue?vue&type=script&lang=js"
export * from "./AposCombo.vue?vue&type=script&lang=js"

import "./AposCombo.vue?vue&type=style&index=0&id=60a7f9c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a7f9c0"],['__file',"ui/ui/apos/components/AposCombo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60a7f9c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60a7f9c0', __exports__)) {
    api.reload('60a7f9c0', __exports__)
  }
  
  module.hot.accept("./AposCombo.vue?vue&type=template&id=60a7f9c0&scoped=true", () => {
    api.rerender('60a7f9c0', render)
  })

}


export default __exports__